module.exports = __webpack_public_path__ + "static/media/awesome.61b20bd9.mp3";